import type { CalendarSource } from "./types.js";

/**
 * The full constellation of Hawaii hashing calendars we read from. Each entry
 * has a fixed `kind` for categorization; the active deployment's primary /
 * secondary / sister grouping is configured in shared/branding.ts.
 *
 * Sources collected across alohah3.com's Pretty Google Calendar shortcode and
 * hawaii.gotothehash.net's calendar embed.
 */
export const CALENDARS: CalendarSource[] = [
  {
    id: "h5",
    name: "Honolulu H5",
    googleCalendarId:
      "jhhk1bllbl4thqk9in5qtffb68@group.calendar.google.com",
    kind: "h5",
    color: "#0a4d2e",
  },
  {
    id: "ah3-main",
    name: "Aloha H3",
    googleCalendarId: "alohahhh@gmail.com",
    kind: "ah3",
    color: "#1f6feb",
  },
  {
    id: "berzerk",
    name: "The Berzerk",
    googleCalendarId:
      "53d9f1f97f06fa4fafe054e19183414d775964da2a8a3ca6dfaa837d707f99fd@group.calendar.google.com",
    kind: "ah3",
    color: "#7a3f00",
  },
  {
    id: "leeward-layabouts",
    name: "Leeward Layabouts Pau Hana",
    googleCalendarId:
      "117947c59f0614411554992bc89d5875c7e52c92237878f70866d6630c86cc31@group.calendar.google.com",
    kind: "ah3",
    color: "#7a5c00",
  },
  {
    id: "kailua-crew",
    name: "Kailua Crew Pau Hana",
    googleCalendarId:
      "5a29bde272723bc47b6894fdc74ccac317dfdd5dc5d3f30cee0933f57479861a@group.calendar.google.com",
    kind: "ah3",
    color: "#0e7c66",
  },
  {
    id: "north-shore-thinking-drinking",
    name: "North Shore Thinking Drinking",
    googleCalendarId:
      "4dffea43b926c5a312e1c0d3ef131083814db0175d653ace654e8baffc94df09@group.calendar.google.com",
    kind: "ah3",
    color: "#8a3ffc",
  },
  {
    id: "labia-h3",
    name: "L.A.B.I.A. H3",
    googleCalendarId:
      "ka2hroq97g7ashjjrfgnev6nk4@group.calendar.google.com",
    kind: "sister",
    color: "#a8071a",
  },
  {
    id: "oahu-pickup-h3",
    name: "Oahu Pickup H3",
    googleCalendarId:
      "a1sin81up5flifi0q03bbhko6k@group.calendar.google.com",
    kind: "sister",
    color: "#0e7c66",
  },
  {
    id: "volcano-h3",
    name: "Volcano H3",
    googleCalendarId:
      "uarvgue998c1mo9jenuvpsq8d4@group.calendar.google.com",
    kind: "sister",
    color: "#c2410c",
  },
];

export const CALENDARS_BY_GCAL_ID = new Map(
  CALENDARS.map((c) => [c.googleCalendarId, c]),
);

export const CALENDARS_BY_ID = new Map(CALENDARS.map((c) => [c.id, c]));
